<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("warehouse") }}</h3>
    <div>
      <div class="admin_container">
        <back-btn class="mb-3" />
        <div class="division_main">
          <warehouse-view-table
            stillage-route-name="reference-warehouse-edit-stillage"
            :data="boardData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseViewTable from "@/components/warehouse/WarehouseViewTable";
import BackBtn from "@/components/ui/BackBtn";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

export default {
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      boardData: {
        rows: [],
        columns: [],
        boards: [],
      },
    };
  },
  components: {
    BackBtn,
    WarehouseViewTable,
  },
  methods: {
    async getBoardData() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("warehouse/board", {
          params: {
            id: this.id,
          },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = boxService.parseData(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    this.showLoading();
    await this.getBoardData();
    this.clearLoading();
  },
};
</script>
